module.exports = __webpack_public_path__ + "img/Urge_Surfing.af5cb29b.svg";